import { type ReactElement, type SVGProps } from 'react';

export const PropertyForSale = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.9909 3H8.99469V20.0002H3.99656V14.9736H2.99694V21.0002H11V20.0002H9.99431V4H17.9913V13H18.9909V3ZM11.9799 13H12.9795V10.0005H11.9799V13ZM14.9789 13H15.9785V10.0005H14.9789V13ZM11.9799 8.00006V5H12.9795V8.00006H11.9799ZM14.9789 5V8.00006H15.9785V5H14.9789ZM2.64562 13.8195L8.55647 8.81716L7.91085 8.05371L2 13.0561L2.64562 13.8195ZM13 17H19V21H13V17ZM12 16H20V22H12V16ZM17 19C17 19.5523 16.5523 20 16 20C15.4477 20 15 19.5523 15 19C15 18.4477 15.4477 18 16 18C16.5523 18 17 18.4477 17 19ZM14 15.5H20.5V19.9004H21.5V14.5H14V15.5Z"
        fill="currentColor"
      />
    </svg>
  );
};
